import { useCallback, useEffect } from 'react';

export function useBeforeUnload(enabled: boolean, message: string) {
    const handleLeave = useCallback(
        (e: BeforeUnloadEvent) => {
            e.preventDefault();

            return message;
        },
        [message],
    );

    useEffect(() => {
        if (!enabled) {
            window.addEventListener('beforeunload', handleLeave);
        }

        return () => {
            window.removeEventListener('beforeunload', handleLeave);
        };
    }, [enabled, handleLeave]);
}
